import Vue from 'vue'
var eventBus = new Vue({});
export default eventBus;



// WEBPACK FOOTER //
// ./src/eventBus.js